import { FlightEventHandler } from './flight'
import { writable } from 'svelte/store'

export default class GcsStatus extends FlightEventHandler {
	constructor(flight) {
		super(flight)

		const { subscribe, set } = writable(null);
		this.subscribe = subscribe
		this.set = set
	}

	handleKeyframe(keyframe) {
		this.set(keyframe.gcsStats.up)
	}

	handleFlightStep(message) {
		if (message.type === 'GCS_UP') {
			this.set(true)
		} else if (message.type === 'GCS_DOWN') {
			this.set(false)
		}
	}
}
